// Labels and tones shared by the Dark Web tabs (#397 step 3d)
import type { StatusTone } from '../../components/ui'

export const STATUS_LABEL: Record<string, string> = {
  new: 'New',
  reviewed: 'Reviewed',
  reset_requested: 'Reset requested',
  resolved: 'Resolved',
  false_positive: 'False positive',
}

export const STATUS_TONE: Record<string, StatusTone> = {
  new: 'critical',
  reviewed: 'warning',
  reset_requested: 'info',
  resolved: 'good',
  false_positive: 'neutral',
}

export function isOpenStatus(status: string): boolean {
  return status !== 'resolved' && status !== 'false_positive'
}

// Leak types in chart order; colors are the categorical series tokens
export const SOURCE_TYPES = [
  { key: 'stealer_log', label: 'Info-stealer logs', short: 'Info-stealer', color: 'bg-series-2', series: 1 },
  { key: 'breach', label: 'Breach dumps', short: 'Breach', color: 'bg-series-1', series: 0 },
  { key: 'combolist', label: 'Combolists', short: 'Combolist', color: 'bg-series-3', series: 2 },
] as const

export function sourceTypeLabel(key: string): string {
  return SOURCE_TYPES.find(s => s.key === key)?.short || key
}

export function sourceTypeColor(key: string): string {
  return SOURCE_TYPES.find(s => s.key === key)?.color || 'bg-muted'
}

export const SOURCE_LABEL: Record<string, string> = { hibp: 'Have I Been Pwned', whiteintel: 'WhiteIntel' }

export function formatDay(ms: number | null | undefined): string {
  if (!ms) return '—'
  return new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatRelative(ms: number | null | undefined): string {
  if (!ms) return 'never'
  const minutes = Math.round((Date.now() - ms) / 60000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.round(minutes / 60)
  if (hours < 48) return `${hours} hour${hours === 1 ? '' : 's'} ago`
  return `${Math.round(hours / 24)} days ago`
}

// Scheduled scans run at 06:00 and 18:00 UTC
export function nextScheduledScan(now = new Date()): string {
  const hour = now.getUTCHours()
  return hour < 6 || hour >= 18 ? '06:00 UTC' : '18:00 UTC'
}
